<template>
  <div>
    <!-- 分阶段指派工程师弹窗 -->
    <el-dialog :title="'指派施工员'" :visible="visible" width="50%" @close="closeDialog" :close-on-click-modal="false"
      append-to-body :z-index="1000">
      <div class="container">
        <!-- 加载状态 -->
        <el-loading v-if="getAllStagesLoading" fullscreen text="加载中..." />
        <!-- 阶段列表表格 -->
        <el-table :data="allStages" border style="width: 100%" v-if="allStages.length > 0 && !getAllStagesLoading">
          <el-table-column label="阶段" width="200">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="当前施工员" width="150">
            <template slot-scope="scope">
              {{ scope.row.engineerName || '未指派' }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <el-button type="text" icon="el-icon-edit" size="small" @click="handleAssignEngineer(scope.row)"
                  :disabled="isAssignDisabled(scope.row)">
                  {{ scope.row.engineerId ? '改派' : '指派' }}
                </el-button>
                <el-button type="text" icon="el-icon-delete" size="small" @click="handleDeleteStage(scope.row)"
                  :disabled="isDeleteDisabled(scope.row)">
                  删除
                </el-button>
                <div v-if="scope.row.errorMessage" class="error-message">
                  {{ scope.row.errorMessage }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增阶段按钮 -->
        <div class="add-stage-section" v-if="allStages.length > 0">
          <el-button type="text" size="small" @click="showAddStageDialog">
            <i class="el-icon-plus"></i> 新增阶段
          </el-button>
        </div>
        <!-- 无阶段提示 -->
        <div class="empty-state" v-if="allStages.length === 0">
          <el-empty description="暂无阶段数据"></el-empty>
          <el-button type="text" size="small" @click="showAddStageDialog">
            <i class="el-icon-plus"></i> 新增阶段
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" type="text" size="small" plain icon="el-icon-close">关闭</el-button>
      </span>
      <!-- 指派施工员弹窗 -->
      <el-dialog :title="'指派施工员'" :visible="assignDialogVisible" width="40%" @close="assignDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="assignForm" label-width="80px">
          <el-form-item label="阶段：" :error="assignForm.errorMessage">
            <span>{{ currentStage ? currentStage.name : '' }}</span>
          </el-form-item>
          <el-form-item label="施工员：" :error="assignForm.errorMessage">
            <el-select v-model="assignForm.engineerId" placeholder="请输入手机号" filterable remote reserve-keyword
              default-first-option :loading="assignSearchLoading" :remote-method="handleRemoteSearchForAssign"
              :popper-append-to-body="false" clearable>
              <el-option v-for="engineer in assignEngineersList" :key="engineer.id" :label="engineer.realName"
                :value="engineer.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="assignDialogVisible = false" type="text" size="small" plain
            icon="el-icon-close">取消</el-button>
          <el-button type="text" size="small" plain icon="el-icon-check" @click="confirmAssign"
            :loading="assignLoading">确认指派</el-button>
        </span>
      </el-dialog>
      <!-- 新增阶段弹窗 -->
      <el-dialog :title="'新增阶段'" :visible="addStageDialogVisible" width="40%" @close="addStageDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="addStageForm" label-width="80px">
          <el-form-item label="选阶段：" :error="addStageForm.errorMessage">
            <el-select v-model="addStageForm.stageId" placeholder="请选择阶段" :loading="availableStagesLoading"
              :popper-append-to-body="false" style="width: 100%">
              <el-option v-for="stage in availableStages" :key="stage.id" :label="stage.name" :value="stage.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addStageDialogVisible = false" plain type="text" size="small"
            icon="el-icon-close">取消</el-button>
          <el-button type="text" size="small" plain icon="el-icon-check" @click="confirmAddStage"
            :loading="addStageLoading">确认添加</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { findUserList } from "@/api/work/projectService";
import { updateWaterProofStage, getPhaseList, getWaterProofStageInfo } from "@/api/work/waterProof/merchants";
import { DIC } from "@/const/dic";
export default {
  name: "AssignEngineerStage",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    stages: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: [String, Number],
      required: true,
    },
    rootDepartId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      allStages: [], // 所有阶段列表
      availableStages: [], // 可添加的阶段列表
      assignDialogVisible: false, // 指派施工员弹窗
      addStageDialogVisible: false, // 新增阶段弹窗
      currentStage: null, // 当前操作的阶段
      assignForm: {
        engineerId: null,
        errorMessage: '',
      },
      addStageForm: {
        stageId: null,
        errorMessage: '',
      },
      assignEngineersList: [], // 指派弹窗的工程师列表
      assignSearchLoading: false, // 指派弹窗工程师搜索加载状态
      assignLoading: false, // 指派加载状态
      availableStagesLoading: false, // 可新增阶段加载状态
      addStageLoading: false, // 新增阶段加载状态
      confirmLoading: false, // 确认指派加载状态
      getAllStagesLoading: false, // 获取阶段列表加载状态
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData();
      }
    },
    orderId(newVal) {
      if (newVal) {
        this.initData();
      }
    },
  },
  methods: {
    // 初始化数据
    async initData() {
      // 先获取阶段详情
      await this.getAllStages();
      // 获取可添加的阶段列表
      this.getAvailableStages();
    },
    // 获取全部阶段列表
    async getAllStages() {
      this.getAllStagesLoading = true;
      try {
        const res = await getWaterProofStageInfo(this.orderId);
        if (res.code === "200") {
          const stagesData = JSON.parse(res.data) || [];
          // 映射API返回字段到组件需要的格式
          this.allStages = stagesData.map(stage => ({
            id: stage.goodsId,
            name: stage.goodsName,
            status: stage.orderStatus,
            isShow: String(stage.isShow),
            engineerId: stage.engineerId,
            engineerName: stage.engineerName,
            errorMessage: '',
            isNewlyAdded: false,
          }));
        } else {
          this.$message.error(res.message || '获取阶段详情失败');
          this.allStages = [];
        }
      } catch (error) {
        this.$message.error('获取阶段详情失败');
        this.allStages = [];
      } finally {
        this.getAllStagesLoading = false;
      }
    },
    // 获取可添加的阶段列表（与工单阶段配置对比）
    async getAvailableStages() {
      this.availableStagesLoading = true;
      try {
        // 调用真实的API获取阶段配置列表
        const res = await getPhaseList(this.rootDepartId);
        if (res.code == "200") {
          const allConfiguredStages = JSON.parse(res.data) || [];
          this.availableStages = this.buildAvailableStages(allConfiguredStages);
        } else {
          this.$message.error(res.message || '获取阶段配置列表失败');
          // 失败时使用模拟数据
          this.availableStages = this.getMockAvailableStages();
        }
      } catch (error) {
        this.$message.error('获取阶段配置列表失败');
      } finally {
        this.availableStagesLoading = false;
      }
    },
    // 统一按字符串处理 stage id，避免 1 和 "1" 比较异常
    normalizeStageId(id) {
      return String(id);
    },
    // 生成可新增阶段：先去重，再排除当前已存在阶段
    buildAvailableStages(allConfiguredStages = []) {
      const existingStageIds = new Set(this.allStages.map(stage => this.normalizeStageId(stage.id)));
      const seenIds = new Set();
      const uniqueStages = [];
      allConfiguredStages.forEach((stage) => {
        const stageId = this.normalizeStageId(stage.id);
        if (!seenIds.has(stageId) && !existingStageIds.has(stageId)) {
          seenIds.add(stageId);
          uniqueStages.push(stage);
        }
      });
      return uniqueStages;
    },
    // 远程搜索工程师（指派弹窗用）
    handleRemoteSearchForAssign(query) {
      if (!query) {
        this.assignEngineersList = [];
        return;
      }
      const params = {
        type: "JOINS_ENGINEER",
        mobile: query,
      };
      this.assignSearchLoading = true;
      findUserList(params).then((res) => {
        if (res.code == "200") {
          const data = JSON.parse(res.data) || [];
          this.assignEngineersList = data;
        } else {
          this.assignEngineersList = [];
        }
      }).finally(() => {
        this.assignSearchLoading = false;
      });
    },
    // 处理指派施工员
    handleAssignEngineer(stage) {
      this.currentStage = stage;
      this.assignForm = {
        engineerId: '',
        engineerName: '',
        errorMessage: '',
      };
      this.assignEngineersList = [];
      this.assignDialogVisible = true;
    },
    // 确认指派
    confirmAssign() {
      if (!this.assignForm.engineerId) {
        this.assignForm.errorMessage = '请选择施工员';
        return;
      }
      this.assignLoading = true;
      // 准备要保存的数据
      const data = {
        declarationId: this.orderId,
        stages: [{
          id: this.currentStage.id,
          engineerId: this.assignForm.engineerId,
        }],
      };
      // 调用接口保存数据
      updateWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('指派成功');
          // 更新本地数据
          const stageIndex = this.allStages.findIndex(s => s.id === this.currentStage.id);
          if (stageIndex !== -1) {
            this.$set(this.allStages, stageIndex, {
              ...this.allStages[stageIndex],
              engineerId: this.assignForm.engineerId,
              engineerName: this.assignEngineersList.find(e => e.id === this.assignForm.engineerId) ? this.assignEngineersList.find(e => e.id === this.assignForm.engineerId).realName : null,
              status: 'WAIT_FOR_ASSIGN',
              errorMessage: '',
            });
          }
          this.assignDialogVisible = false;
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '指派失败');
        }
      }).finally(() => {
        this.assignLoading = false;
      });
    },
    // 处理删除阶段
    handleDeleteStage(stage) {
      if (this.isDeleteDisabled(stage)) {
        this.$message.warning('当前阶段不可删除');
        return;
      }
      this.$confirm('确定要删除该阶段的指派吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除逻辑说明：
        // 1) isShow=2（基础必有阶段）只允许改指派，不允许删除；
        // 2) 其他阶段允许删除，按后端约定通过 engineerId=null 下发删除动作。
        const data = {
          declarationId: this.orderId,
          stages: [{
            id: stage.id,
            engineerId: null,
          }],
        };
        // 调用接口保存数据
        updateWaterProofStage(data).then((res) => {
          if (res.code == "200") {
            this.$message.success('删除成功');
            // 更新本地数据
            const stageIndex = this.allStages.findIndex(s => s.id === stage.id);
            if (stageIndex !== -1) {
              this.$set(this.allStages, stageIndex, {
                ...this.allStages[stageIndex],
                engineerId: null,
                engineerName: null,
                status: 'WAIT_FOR_ASSIGN',
              });
            }
            this.$emit('refresh');
          } else {
            this.$message.error(res.message || '删除失败');
          }
        });
      }).catch(() => {
        // 取消删除
      });
    },
    // 显示新增阶段弹窗
    async showAddStageDialog() {
      this.addStageForm = {
        stageId: null,
        errorMessage: '',
      };
      // 先刷新阶段配置，确保首次打开就可选择且去重后的列表为最新
      await this.getAvailableStages();
      this.addStageDialogVisible = true;
    },
    // 确认添加阶段
    confirmAddStage() {
      if (!this.addStageForm.stageId) {
        this.addStageForm.errorMessage = '请选择阶段';
        return;
      }
      this.addStageLoading = true;
      // 获取选中的阶段信息
      const selectedStage = this.availableStages.find(
        s => this.normalizeStageId(s.id) === this.normalizeStageId(this.addStageForm.stageId)
      );
      if (!selectedStage) {
        this.addStageForm.errorMessage = '阶段数据未准备好，请重试';
        return;
      }
      // 准备要保存的数据
      const data = {
        declarationId: this.orderId,
        stages: [{
          id: selectedStage.id,
          engineerId: null,
        }],
      };
      // 调用接口保存数据
      updateWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('新增阶段成功');
          // 添加到本地列表
          this.allStages.push({
            id: selectedStage.id,
            name: selectedStage.name,
            status: 'WAIT_FOR_ASSIGN',
            isShow: "1",
            engineerId: null,
            engineerName: null,
            isNewlyAdded: true,
            errorMessage: '',
          });
          // 更新可添加阶段列表
          this.getAvailableStages();
          this.addStageDialogVisible = false;
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '新增阶段失败');
        }
      }).finally(() => {
        this.addStageLoading = false;
      });
    },
    // 是否已提交工单或已核销（此类阶段不可再次指派/删除）
    isSubmittedOrWrittenOff(stage) {
      const lockedStatus = [
        'IN_SERVICE',
        'TO_BE_THE_FINAL',
        'TO_BE_ACCEPTED',
        'UNDER_ACCEPTANCE',
        'COMPLETE',
        'ACCEPTANCE_COMPLETED',
      ];
      return lockedStatus.includes(stage.status);
    },
    // 指派按钮禁用判断：仅在已提交工单/已核销后禁用
    isAssignDisabled(stage) {
      return this.isSubmittedOrWrittenOff(stage);
    },
    // 删除按钮禁用判断：isShow=2不可删，且已提交工单/已核销不可删
    isDeleteDisabled(stage) {
      if (stage.isShow === "2") {
        return true;
      }
      return this.isSubmittedOrWrittenOff(stage);
    },
    // 获取状态类型
    getStatusType(status) {
      switch (status) {
        case 'WAIT_FOR_ASSIGN':
        case 'WAIT_DISTRIBUTE':
          return 'warning';
        case 'IN_SERVICE':
        case 'TO_BE_THE_FINAL':
        case 'TO_BE_ACCEPTED':
        case 'UNDER_ACCEPTANCE':
          return 'info';
        case 'COMPLETE':
        case 'ACCEPTANCE_COMPLETED':
          return 'success';
        default:
          return '';
      }
    },
    // 获取状态标签
    getStatusLabel(status) {
      const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
      return statusItem ? statusItem.label : status;
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style scoped>
.container {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 10px;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.empty-state .el-button {
  margin-top: 20px;
}

.dialog-footer {
  text-align: right;
}

/* 滚动条样式 */
.container::-webkit-scrollbar {
  width: 8px;
}

.container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 表格样式 */
.el-table {
  margin-bottom: 20px;
}

.el-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}

/* 操作按钮样式 */
.operation-buttons {
  display: flex;
  gap: 8px;
}

.operation-buttons .el-button {
  padding: 4px 12px;
}

/* 新增阶段按钮样式 */
.add-stage-section {
  margin-top: 20px;
  text-align: right;
}

/* 错误提示样式 */
.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 0;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

/* 表格错误提示样式 */
.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}
</style>